export * from './trainForFirstExercise';
export * from './restForFirstExercise';
export * from './transitionForRest';
export * from './transitionForTrain';
export * from './restForSecondExercise';
export * from './trainForThirdExercise';
export * from './trainForSecondExercise';
export * from './restForThirdExercise';
export * from './transitionForRestWithBenchInstruction';
export * from './trainForFirstExerciseWithoutTechniqueTip';
export * from './trainForSecondExerciseWithoutTechniqueTip';
export * from './trainForFourthExercise';
export * from './restForFourthExercise';
